/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {EditRequestIsPendingForTimecardRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {EditRequestIsPendingForTimecardResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const editRequestIsPendingForTimecard = (request: EditRequestIsPendingForTimecardRequest, options?: CashRequestOptions) => post<EditRequestIsPendingForTimecardRequest, EditRequestIsPendingForTimecardResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/EditRequestIsPendingForTimecard", request, {...options, rejectOnError: true })